// extracted by mini-css-extract-plugin
export default {"modalouter":"Query_modalouter__E-wQA","buttonsection":"Query_buttonsection__H6xP7"};